export default "__VITE_ASSET__Bo4Gz0gD__"